import { datadogRum } from '@datadog/browser-rum'

export const reportError = (message: string, originalError?: unknown) => {
  const error = new Error(message, {
    cause: originalError instanceof Error ? originalError : undefined,
  })

  datadogRum.addError(error)
}
